module.exports = __webpack_public_path__ + "static/media/delete.63c7c766.svg";